import { CustomerLogo } from '@sequencehq/core-components'

import { InboxListItemContent } from 'Automations/components'
import { useManualTaskListItemContentToolkit } from 'Automations/nodeDefinitions/hooks/useManualTaskListItemContentToolkit'
import { getManualTaskStatusIcon } from 'Automations/nodeDefinitions/hooks/getManualTaskStatusIcon'
import { getLogoSrc } from 'Customer/utils/logo'
import { CustomerInfoReviewInput, CustomerInfoReviewOutcome } from '../../types'
import {
  getChangeSummaryTitle,
  mapInputToViewModel
} from '../../customerInfoDiff'

export const CustomerInfoReviewListItemContent = ({
  taskId,
  isSelected,
  hideUnreadIndicator,
  onClick
}: {
  taskId: string
  isSelected: boolean
  hideUnreadIndicator?: boolean
  onClick: (e: React.MouseEvent<HTMLDivElement, MouseEvent>) => void
}) => {
  const { manualTask, isUnread, preload } =
    useManualTaskListItemContentToolkit<CustomerInfoReviewInput>({ taskId })

  if (!manualTask?.input) {
    return <InboxListItemContent.Loading />
  }

  const { customer, summary, sections } = mapInputToViewModel(manualTask.input)

  // A dismissed review completes as COMPLETED (not CANCELLED), so the status
  // alone can't tell it apart from a confirmed one — read the recorded outcome
  // so a dismissal shows the negative (X) icon rather than the success check.
  const outcome = (manualTask.output as CustomerInfoReviewOutcome | null)
    ?.outcome
  const statusIcon = getManualTaskStatusIcon(manualTask.status, outcome)

  return (
    <InboxListItemContent
      isSelected={isSelected}
      isUnread={hideUnreadIndicator ? undefined : isUnread}
      onClick={onClick}
      onPreload={preload}
      title={`${customer.legalName}: ${getChangeSummaryTitle(sections)}`}
      description={summary}
      createdAt={manualTask.createdAt}
      statusIcon={statusIcon}
      icon={
        <InboxListItemContent.TaskIcon isSelected={isSelected}>
          <CustomerLogo
            src={getLogoSrc(customer)}
            size={24}
            fallbackSize={16}
            data-testid="watchtower.customerInfoReview.listItem.logo"
          />
        </InboxListItemContent.TaskIcon>
      }
    />
  )
}
